import CONFIG from '../../../../../consts/candle_tree_tiers.json';

export const HAUNT_COUNTER_TIERS = CONFIG.TREE;

export const CANDLE_TIERS = CONFIG.CANDLE;
